import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import CustomButton from "../Button";
import { icons } from "../../constants";
import { styled } from "@mui/material/styles";

const StyledDialog = styled(Dialog)(() => ({
  "& .MuiDialogContent-root": {
    padding: "0 16px",
  },
  "& .MuiDialog-scrollPaper": {
    padding: "0 16px",
  },
  "& .MuiDialog-paperFullWidth": {
    minWidth: "100%",
  },
  "& .MuiDialog-paperScrollPaper": {
    maxHeight: "100%",
  },
}));

const Alert = ({
  title,
  description,
  isOpen,
  isCS,
  isCancel,
  isObject,
  handleClose,
  handleAction,
  handleCancel,
  btnTxt,
  cancelTxt,
  swapButtonsPosition = false,
  withCloseButton = false,
  cancelButtonTestId,
  okButtonTestId,
  style,
  additionalContent,
  titleStyle,
  submitButtonDisabled,
  submitButtonStyle,
}) => {
  const split = text => {
    return text
      .replace(/([A-Z])/g, " $1")
      .replace(/^./, str => str.toUpperCase());
  };

  const paddingTop = withCloseButton ? { paddingTop: "36px" } : {};

  return (
    <StyledDialog
      fullWidth
      open={isOpen}
      onClose={handleClose}
      onClick={handleCancel}
      style={style}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{ position: withCloseButton && "relative" }}
      >
        {withCloseButton && (
          <img
            src={icons.close}
            alt="Close modal"
            style={{ position: "absolute", right: "1rem", top: "1rem" }}
            onClick={handleCancel}
          />
        )}

        <DialogTitle
          sx={{
            padding: "24px 16px 0px",
            ...paddingTop,
          }}
        >
          <Typography
            sx={{
              fontSize: "20px",
              fontWeight: "700",
              lineHeight: 1.4, //28px
              color: "#000",
            }}
            style={titleStyle}
          >
            {title}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ overflowY: "auto", marginTop: "5px" }}>
          {!isObject ? (
            <>
              <Typography sx={{ color: "#333" }}>{description}</Typography>
              {isCS && (
                <Typography sx={{ marginTop: "16px" }}>
                  Please contact our <strong>Customer Service</strong> for
                  assistance.
                </Typography>
              )}
            </>
          ) : (
            <>
              {Object.keys(isObject)
                .filter(key => isObject[key])
                .map(key => {
                  return (
                    <Typography key={key} sx={{ color: "#333" }}>
                      &#183; {split(key)}
                    </Typography>
                  );
                })}
            </>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            padding: "0px 16px 24px",
            margin: 0,
            display: "flex",
            flexDirection: isCancel ? "column" : "row",
            ...(submitButtonStyle || {}),
          }}
        >
          {swapButtonsPosition ? (
            <>
              <CustomButton
                text={cancelTxt ? cancelTxt : "Cancel"}
                color="#fff"
                backgroundColor="#1278cc"
                onClick={handleCancel}
                testId={cancelButtonTestId}
              />
              <Button
                onClick={handleAction}
                sx={{
                  color: "#0076CF",
                  marginTop: "16px",
                  padding: 0,
                  textTransform: "capitalize",
                  lineHeight: "20px",
                  fontSize: "16px",
                  marginLeft: "0 !important"
                }}
                data-cy={okButtonTestId}
                disabled={submitButtonDisabled}
              >
                {btnTxt ? btnTxt : "Done"}
              </Button>
            </>
          ) : (
            <>
              <CustomButton
                text={btnTxt ? btnTxt : "Done"}
                color="#fff"
                backgroundColor="#1278cc"
                onClick={handleAction}
                data-cy={okButtonTestId}
                disabled={submitButtonDisabled}
                style={{ marginTop: "16px" }}
              />
              {isCancel && (
                <Button
                  onClick={handleCancel}
                  sx={{
                    color: "#0076CF",
                    marginTop: "16px",
                    padding: 0,
                    textTransform: "capitalize",
                    lineHeight: "20px",
                    marginLeft: "0 !important",
                    fontSize: "16px",
                  }}
                  data-cy={cancelButtonTestId}
                >
                  {cancelTxt ? cancelTxt : "Cancel"}
                </Button>
              )}
            </>
          )}
        </DialogActions>
        {additionalContent && (
          <DialogContent>{additionalContent}</DialogContent>
        )}
      </div>
    </StyledDialog>
  );
};

export default Alert;
